// smooth scroll setting
    const lenis = new Lenis({
      lerp: .1, // Linear interpolation (lerp) intensity (between 0 and 1)
      duration: 2, // The duration of scroll animation (in seconds). Useless if lerp defined
      smooth:true,
    });

const parallaxEls = document.querySelectorAll('.parallax-bg');
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    entry.target.classList.toggle('in-view', entry.isIntersecting);
  });
}, { threshold: 0 });

parallaxEls.forEach(el => observer.observe(el));

const extraRatio = 0.15;
const extras     = Array.from(parallaxEls).map(el => el.clientHeight * extraRatio);
const speed      = 0.5;
const vh         = window.innerHeight;

function raf(time) {
  lenis.raf(time);

  parallaxEls.forEach((el, i) => {
    if (!el.classList.contains('in-view')) return;  // ビュー外はスキップ

    const rect = el.getBoundingClientRect();
    const h    = rect.height;
    const t    = Math.min(1, Math.max(0, (vh - rect.top) / (vh + h)));
    const offset = extras[i] * (t - 0.5);

    el.style.backgroundPosition = `center ${offset}px`;
  });

  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);






/*
window.addEventListener('scroll', function(){
  if( 100 < window.scrollY ) {
    document.querySelector(".section--header").classList.add('scrolled');
  } else {
    document.querySelector(".section--header").classList.remove('scrolled');
  }
});
*/






const opener = document.querySelector('.menu-btn');
opener.addEventListener("click", function() {
  document.querySelector('#header').classList.toggle('is-active');
});
const closer = document.querySelector('.close-button');
closer.addEventListener("click", function() {
  document.querySelector('#header').classList.remove('is-active');
});






